import DOMPurify from 'dompurify'

// Centralized HTML sanitizer for the app
export function sanitizeHtml(html) {
  if (!html) return ''
  const cleaned = DOMPurify.sanitize(html, {
    ALLOWED_TAGS: [
      'b',
      'i',
      'u',
      'a',
      'ul',
      'ol',
      'li',
      'p',
      'br',
      'span',
      'strong',
      'em',
      'blockquote',
      'h1',
      'h2',
      'h3',
      'h4',
      'h5',
      'h6',
      'pre',
      'code',
      'hr',
      's',
      'strike',
      'del',
      'div',
      'center',
      'left',
      'right',
      'justify'
    ],
    ALLOWED_ATTR: ['href', 'target', 'rel', 'src', 'alt', 'title']
  })

  // Remove any remaining inline styles
  const temp = document.createElement('div')
  temp.innerHTML = cleaned
  const elementsWithStyle = temp.querySelectorAll('[style]')
  elementsWithStyle.forEach((el) => el.removeAttribute('style'))

  return temp.innerHTML
}
